import { useState, createContext, useContext, useRef } from 'react';
import Navigation from '../../components/Navigation';
import MobileNavigation from '../../components/MobileNavigation';
import { useClickOutside } from '../hooks/useClickOutside';

const NavigationContext = createContext();

export const useNavigation = () => useContext(NavigationContext);

export const NavigationContextProvider = ({ children }) => {
    const [ showNavigation, setShowNavigation ] = useState(true);

    const collectionMenuBtnRef = useRef(null);
    const [ collectionMenuRef, showCollectionMenu, setShowCollectionMenu ] = useClickOutside(false, collectionMenuBtnRef);

    const [ pinned, setPinned ] = useState(false);
    
    return (
        <NavigationContext.Provider value={{ 
            showNavigation, 
            setShowNavigation,
            collectionMenuBtnRef,
            collectionMenuRef,
            showCollectionMenu,
            setShowCollectionMenu,
            pinned,
            setPinned
        }}>
            {children}
        </NavigationContext.Provider>
    );
};


export const NavigationConditional = () => {
    const { showNavigation } = useNavigation();

    if (!showNavigation) return <></>;

    return (
        <>
        <Navigation />
        <MobileNavigation />
        </>
    );
};